export default class MyAccountAddresses {
    constructor() {
        this.Add = document.getElementById("add_address");

        // SOAP on the server must be enabled!
        if (this.Add) {
            this.events();
        }
    }

    events() {
        (function ($) {
            jQuery(".delete_address").on("click", function (e) {
                e.preventDefault();
                jQuery(this).parents("div.address_block").remove();
            });
        })(jQuery);
    }
}
